import Route from '@ember/routing/route'
import { service } from '@ember/service'
import type Store from '@ember-data/store'
import { assert } from '@ember/debug'
import type Student from 'teacher-ui-client/models/student'
import { hasId } from 'teacher-ui-client/utils/type-guards'

export default class FastPhonicsReportingDashboardStudentRoute extends Route {
  @service store!: Store

  model({ student_id: studentId }: { student_id: string }) {
    const student = this.store.peekRecord<Student>('student', studentId)
    assert('could not find student in ember-data store', student && hasId(student))

    return { student }
  }
}
